import { AlertType } from '../../../../types/campaign'

export interface CampaignTableFiltersProps {
  onSubmit: () => void
}

export type FiltersForm = UiFilters & FiltersMeta

export interface Filters {
  alerts: AlertType[]
  cities: string[]
  agencies: string[]
  mediaFormats: string[]
  startDateFrom: string
  startDateTo: string
  endDateFrom: string
  endDateTo: string
  statuses: string[]
  text: string
  targets: string[]
  commercialAttributes: string[]
  buildings: string[]
  campaignTags: string[]
  isBundleCampaign: boolean | null
}

export interface UiFilters extends Omit<Filters, 'isBundleCampaign'> {
  bundleCampaign: boolean[]
  campaignTags: string[]
}

export interface FiltersMeta {
  citiesAll: Filters['cities']
  agenciesAll: Filters['agencies']
  mediaFormatsAll: Filters['mediaFormats']
  statusesAll: Filters['statuses']
  alertsTypeAll: Filters['alerts']
  targetsAll: Filters['targets']
  commercialAttributesAll: Filters['commercialAttributes']
  buildingsAll: Filters['buildings']
  isBundleCampaignAll: boolean[]
}

export const filtersDefault: UiFilters = {
  agencies: [],
  alerts: [],
  cities: [],
  endDateFrom: '',
  endDateTo: '',
  mediaFormats: [],
  startDateFrom: '',
  startDateTo: '',
  statuses: [],
  text: '',
  targets: [],
  commercialAttributes: [],
  buildings: [],
  bundleCampaign: [],
  campaignTags: [],
}

export const filtersFormDefault: FiltersForm = {
  ...filtersDefault,
  citiesAll: [],
  agenciesAll: [],
  mediaFormatsAll: [],
  statusesAll: [],
  alertsTypeAll: [AlertType.alert, AlertType.info],
  targetsAll: [],
  commercialAttributesAll: [],
  buildingsAll: [],
  isBundleCampaignAll: [true, false],
}
